import React from "react";

import StandModals from "../modals";
import { FilterParamsList } from "components/service";


const StandFilterBlock = ( { sort, filter } ) => {

    return(
        <div className="filter-block stand-filter-block">
            <div className="modals grid-two-col">
                <StandModals.Filter filter = { filter } />
                <StandModals.Sort sort={ sort } />
            </div>
            <FilterParamsList
                filter = { filter }
                fieldsArr={ [ "where", "whereCrafts" ] }
            />
        </div>
    )
}

export default StandFilterBlock;